export const URL = process.env.URL
export const API_URL = process.env.API_URL
export const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID
export const SENTRY_DSN = process.env.SENTRY_DSN
export const ORCHARD_OA_URL = process.env.ORCHARD_OA_URL
